/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersCreateIn } from '../../models/members-create-in';
import { MembersWithoutSupplierData } from '../../models/members-without-supplier-data';

export interface CreateMemberApiV2SecretariatMembersPost$Params {
  org: string;
      body: MembersCreateIn
}

export function createMemberApiV2SecretariatMembersPost(http: HttpClient, rootUrl: string, params: CreateMemberApiV2SecretariatMembersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
  const rb = new RequestBuilder(rootUrl, createMemberApiV2SecretariatMembersPost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersWithoutSupplierData>;
    })
  );
}

createMemberApiV2SecretariatMembersPost.PATH = '/api/v2/secretariat/members';
